import type { I18nPrefix } from '../../i18n/prefix';

export const I18N_PAGE = 'features:products.pages.products_sync_page' satisfies I18nPrefix;
export const I18N_DATA_PAGE = 'features:products.pages.product_data_page' satisfies I18nPrefix;
export const I18N_COMPONENTS = 'features:products.components' satisfies I18nPrefix;

export const PRODUCTS_SYNC_PATH = '/integrations/products-sync';

const DOCS_BASE = 'https://docs.sparklayer.io';

export const DOCS_URLS = {
  dataSync: `${DOCS_BASE}/data-sync`,
  dataSyncLookup: `${DOCS_BASE}/data-sync#SWBMA`,
  troubleshooting: `${DOCS_BASE}/troubleshooting#A3ozG`,
  stockDisplay: `${DOCS_BASE}/stock-display#4ii2E`,
  stockLocations: `${DOCS_BASE}/customers#jyPsM`,
} as const;
